import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useFeature, useViewerRoles } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { ModeSwitch } from '@treams/treams-ui';

import { useManagerMode } from './ManagerModeContext';

const Container = styled(Box)`
	flex-shrink: 0;
	min-width: 0;
	margin-bottom: ${(props) => props.theme.tokens.gap.section}px;
`;

const MoreInfo = styled(Box)`
	color: ${(props) => props.theme.tokens.text.secondary};
	text-decoration: underline;
	text-align: center;
`;

export default function ManagerModeSwitch() {
	const { t } = useTranslation();
	const history = useHistory();
	const managermode = useManagerMode();
	const usesManagerMode = useFeature(graphql.FeatureName.Helicopter);
	const { isWorkspaceSuperuser, isManager } = useViewerRoles();

	if (!usesManagerMode || (!isWorkspaceSuperuser && !isManager)) {
		return null;
	}

	const toggleManagerMode = () => {
		if (managermode.enabled) {
			history.push('/');
			managermode.disable();
			return;
		}

		history.push('/manager');
		managermode.enable();
	};

	return (
		<Container>
			<ModeSwitch
				value={managermode.enabled ? 'managing' : 'personal'}
				personalLabel={t('sidebar.mode.personal')}
				managingLabel={t('sidebar.mode.team')}
				onChange={(value) => {
					if (value === 'managing' && !managermode.enabled) {
						toggleManagerMode();
					}
					if (value === 'personal' && managermode.enabled) {
						toggleManagerMode();
					}
				}}
			/>
			{managermode.enabled && (
				<MoreInfo mt={2}>
					<a href={t('sidebar.manager.helicopterInfo.link')} target="_blank" rel="noreferrer">
						{t('sidebar.manager.helicopterInfo.text')}
					</a>
				</MoreInfo>
			)}
		</Container>
	);
}
